/**
 * CurveSlider
 * @class CurveSlider
 * @description スライダー
 * @example
 * new CurveSlider();
 * @requires Splide
 */


import Swiper from 'swiper/bundle';

export default class CurveSlider {
  constructor() {


    this.sliders = [...document.querySelectorAll('.curve-slider .swiper')];
    // console.log(this.sliders);
    if(this.sliders.length < 1) return;

    this.sliders.forEach(el => {
      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');
      const pagination = el.querySelector('.swiper-pagination');
     const curveSlider = new Swiper(el, {
        // Optional parameters
        loop: true,
        loopedSlides: 0,
        loopAdditionalSlides: 1,

        slidesPerView: 1.4,
        spaceBetween: 0,
        centeredSlides: true,

        speed: 500,
        // autoplay: {
        //   delay: 1000,
        // },
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        // カスタムエフェクトを設定
        effect: "creative",
        creativeEffect: {
          limitProgress: 3,
          prev: {
            translate: ["-115%", "-21%", 1],
            rotate: [0, 0, 5.6],
            opacity: 1, // numberを設定する
            scale: 1, // numberを設定する
            shadow: false, // true or false
            origin: "center bottom", // スライドの原点を指定
          },
          next: {
            translate: ["115%", "-21%", 1],
            rotate: [0, 0, -5.6],
            opacity: 1, // numberを設定する
            scale: 1, // numberを設定する
            shadow: false, // true or false
            origin: "center bottom", // スライドの原点を指定
          }
        },

        breakpoints: {

          1000: {
            // slidesPerView: 2.4,
            slidesPerView: 'auto',
            creativeEffect: {
              limitProgress: 3,
              prev: {
                translate: ["-115%", "-15%", 1],
                rotate: [0, 0, 5.6],
                opacity: 1, // numberを設定する
                scale: 1, // numberを設定する
                shadow: false, // true or false
                origin: "center bottom", // スライドの原点を指定
              },
              next: {
                translate: ["115%", "-15%", 1],
                rotate: [0, 0, -5.6],
                opacity: 1, // numberを設定する
                scale: 1, // numberを設定する
                shadow: false, // true or false
                origin: "center bottom", // スライドの原点を指定
              }
            },
          }
          // ,1600: {
          //   slidesPerView: 3,
          // }
        },

  on: {
    slideChangeTransitionEnd: function () {
      // document.querySelectorAll('.swiper-slide a').forEach(function(anchor) {
      //   anchor.setAttribute('tabindex', '-1');
      // });
      // document.querySelectorAll('.swiper-slide-active a').forEach(function(anchor) {
      //   anchor.setAttribute('tabindex', '0');
      // });
    }
  }

      });
      }
    );



  }


}
